module.exports = window.XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./node_modules/httpplease/lib/xhr-browser.js
// module id = 195
// module chunks = 0